import _ from 'underscore'
import resolve from 'ioc/resolve'
import webfonts from 'webfonts/webfonts'
import webcolors from 'webcolors/webcolors'
import fabric from 'emun.on-demand/lib/fabric'
import config from 'emun.on-demand/_fabric.config'
import angular from 'angular'

function splatName(name) {
    return {
        id: name,
        isBackground: name.toLowerCase().indexOf('c-background') > 0,
        isNonEditable: name.substring(0, 1) === 'N',
        isEditable: name.substring(0, 1) === 'E',
        isBase: name.substring(1, 2) === 'B',
        isFront: name.substring(1, 2) === 'F',
        isTop: name.substring(1, 2) === 'T',
        isImage: name.substring(2, 3) === 'I',
        isGroup: name.substring(2, 3) === 'G',
        isCentered: name.substring(2, 3) === 'X',
        isIcon: name.substring(2, 3) === 'M',
        isLeft: name.substring(2, 3) === 'L',
        isRight: name.substring(2, 3) === 'R',
        isCenterAligned: name.substring(2, 3) === 'P',
        isText: ['X', 'L', 'R', 'P'].indexOf(name.substring(2, 3)) >= 0,
        canSeeInLayers: ['X', 'L', 'I', 'M', 'G', 'C', 'S'].indexOf(name.substring(2, 3)) >= 0,
        canChangeColor: ['X', 'L', 'M', 'C', 'S'].indexOf(name.substring(2, 3)) >= 0,
        isMovable: ['X', 'L', 'I', 'M', 'G', 'S', 'R', 'P'].indexOf(name.substring(2, 3)) >= 0 && ['E', 'M'].indexOf(name.substring(0, 1)) >= 0,
        isDesign: name.substring(2, 3) === 'D',
        isColor: name.substring(2, 3) === 'C',
        isShape: name.substring(2, 3) === 'S',
        type: name.substring(0, 3),
        name: name.substring(4).replace('_', ' ')
    }
}

const boundsTolerance = 88;
function isOutOfBounds(o, bounds) {
    return o && bounds && (o.left + o.width > bounds.width + boundsTolerance ||
        o.left < 0 - boundsTolerance ||
        o.top + o.height > bounds.height + boundsTolerance ||
        o.top < 0 - boundsTolerance);
}

function filterObservableFactory(filterType, propertyName) {
    const Type = fabric.Image.filters[filterType];
    return function (value) {
        const set = arguments.length > 0;
        const layer = this;
        let filters = [];
        layer.objects.forEach(o => {
            o.filters.forEach(f => {
                if (f.type === filterType) {
                    filters.push(f);
                    set && (f[propertyName] = value);
                }
            });
        });
        if (set) {
            if (!filters.length) {
                let options = {
                    [propertyName]: value
                }
                let f = new Type(options);
                filters.push(f);
                layer.objects.forEach(o => o.filters.push(f));
            }
            layer.objects.forEach(o => o.applyFilters());
            resolve('$rootScope').$emit('designerObjectModified', { propertyName, layer });
        }
        for (var i in filters)
            return filters[i][propertyName];
        return null;
    }
};

function simpleObservableFactory(propertyName) {
    var properties = arguments;
    return function (value) {
        var layer = this;
        if (value) {
            layer.objects.forEach(o => o.set(propertyName, value));
            resolve('$rootScope').$emit('designerObjectModified', { propertyName, layer });
        }
        return layer.objects[0].get(propertyName);
    }
};

function observableFactory(propertyName) {
    let properties = arguments;
    return function (value) {
        const layer = this;
        if (arguments.length) {
            angular.forEach(properties, p => {
                if (p === 'Fill' || p === 'Tint') {
                    value = webcolors.format(value);
                }
                angular.forEach(layer.objects, o => {
                    switch (p) {
                        case 'Tint':
                            if (o.type === 'image') {
                                o.filters = [new fabric.Image.filters.Tint({
                                    color: value,
                                    opacity: 1
                                })];
                                o.applyFilters(() => resolve('$rootScope').$emit('designerObjectModified', { p, layer }));
                            }
                            break;
                        case 'Text':
                            if (angular.isFunction(o.setText)) {
                                o.setText(value !== null && value !== undefined ? value : '');
                                o.setCoords();
                            }
                            break;
                        default:
                            if (true || o.type !== 'image') {
                                if (angular.isFunction(o['set' + p])) {
                                    o['set' + p](value);
                                    o.setCoords();
                                }
                            }
                            break;
                    }
                });
                //layer.render();
                resolve('$rootScope').$emit('designerObjectModified', { p, layer });
            });
        }
        return layer.objects.map(o => o['get' + propertyName]()).filter(o => o !== null && o !== undefined)[0];
    }
};

function reduceWebFonts(objects) {
    var d = this;
    var fonts = {};
    (objects || d.objects).forEach(function sniffObject(o) {
        if (o.fontFamily && !fonts[o.fontFamily] && webfonts.map[o.fontFamily]) {
            fonts[o.fontFamily] = webfonts.map[o.fontFamily];
        }
        if (o.objects) o.objects.forEach(sniffObject);
    });
    return fonts;
}

function isUrl(val) {
    var i = val.indexOf('//');
    return i >= 0 && i < 8;
}

function iDontMove(o, layer) {
    //console.log('iDontMove', o, layer);
    o.set({
        selectable: false,
        hasControls: false,
        hasBorders: false,
        hoverCursor: layer && layer.isColor && !layer.isBackground ? 'pointer' : 'default',
        moveCursor: 'default',
        hasBorders: false,
        lockMovementX: true,
        lockMovementY: true,
        lockScalingX: true,
        lockScalingY: true,
        lockUniScaling: true,
        lockRotation: true
    });
}

function loadFonts(objects) {
    var promises = [];
    const $q = resolve('$q');
    angular.forEach(objects, o => {
        var deferred = $q.defer();
        if (o.fontFamily) {
            promises.push(deferred.promise);
            webfonts.load(o.fontFamily)
                .then((args) => {
                    resolve('$timeout')(() => {
                        o.set({
                            fontFamily: args.font.family
                        });
                        deferred.resolve({ args, o });
                        resolve('$rootScope').$emit('renderDesigner', { args, o });
                    }, 100)
                });
        }
    });
    return $q.all(promises);
}

function getTranslatedScale(from, to, cover) {
    let result = {
        cover: !!cover,
        contain: !cover,
        from,
        to,
        widthRatio: to.width / from.width,
        heightRatio: to.height / from.height,
        topOffset: 0,
        leftOffset: 0
    };

    result.multiplier = Math[(cover ? 'max' : 'min')](result.widthRatio, result.heightRatio);

    if ((result.widthRatio > result.heightRatio) || result.contain) {
        result.topOffset = ((from.height * result.multiplier) - to.height) / 2;
    }
    if ((result.heightRatio > result.widthRatio) || result.contain) {
        result.leftOffset = ((from.width * result.multiplier) - to.width) / 2;
    }
    return result;
}

function translateObjects(objects, scale) {
    function transpose(o, i) {
        console.warn('before', i, { ...o });
        o.scaleX = o.scaleX * scale.multiplier;
        o.scaleY = o.scaleY * scale.multiplier;
        o.left = (o.left * scale.multiplier) - scale.leftOffset;
        o.top = (o.top * scale.multiplier) - scale.topOffset;
        console.warn('after', o);
    }

    if (scale && scale.multiplier > 0 && scale.multiplier != 1) {
        objects.forEach(transpose);
    }
}

function getContainScale(source, target, maxZoom) {
    var scale = {
        x: target.width / source.width,
        y: target.height / source.height
    };
    var result = Math.min(scale.x, scale.y, maxZoom || 1);

    return result;
}

function getCoverScale(source, target, maxZoom) {
    var scale = {
        x: target.width / source.width,
        y: target.height / source.height
    };
    var result = Math.min(Math.max(scale.x, scale.y), maxZoom || 1);

    return result;
}

function generateOverlay(width, height, overscan, buffer) {
    if (!buffer) buffer = 3;
    let canvas = new fabric.StaticCanvas();
    let canvasDimiensions = {
        width: width + 2 * buffer,
        height: height + 2 * buffer
    };
    let dashWidth = Math.min(width, height) / 25;
    let strokeWidth = dashWidth / 6;

    canvas.setDimensions(canvasDimiensions);

    //overscan/bleed
    canvas.add(new fabric.Rect({
        left: buffer,
        top: buffer,
        width: width - overscan,
        height: height - overscan,
        strokeWidth: overscan,
        opacity: .45,
        fill: 'rgba(0,0,0,0)',
        stroke: '#fff'
    }));

    //frame -- TODO: consider clipping
    let frame = new fabric.Rect({
        width: canvasDimiensions.width - (buffer),
        height: canvasDimiensions.height - (buffer),
        strokeWidth: buffer,
        fill: 'rgba(0,0,0,0)',
        stroke: 'rgba(155,155,155,0.8)'
    })
    //frame.setShadow({ color: 'rgba(255,0,0,0.6)' });
    canvas.add(frame);

    //bleed line
    canvas.add(new fabric.Rect({
        left: buffer + (overscan - strokeWidth / 2),
        top: buffer + (overscan - strokeWidth / 2),
        width: width - (2 * overscan),
        height: height - (2 * overscan),
        strokeWidth: strokeWidth,
        fill: 'rgba(0,0,0,0)',
        stroke: 'rgba(0,0,0,0.3)',
        strokeDashArray: [dashWidth, dashWidth]
    }));

    return canvas.toDataURL('png');
}

let utils = {
    splatName,
    emptyGif: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    extendedProperties: config.extendedProperties,
    loadFonts,
    reduceWebFonts,
    getContainScale,
    getCoverScale,
    getTranslatedScale,
    translateObjects,
    filterObservableFactory,
    simpleObservableFactory,
    observableFactory,
    isUrl,
    isOutOfBounds,
    generateOverlay,
    iDontMove
};

export default utils;